import { PlaceholderPage } from './PlaceholderPage'

export default function Symon() {
  return <PlaceholderPage title="Symon" route="/symon" />
}
